import React from 'react';

function WordDocIcon() {
  return (
    <svg
      width="76"
      height="101"
      viewBox="0 0 76 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63 94.5571C66.3203 94.5571 69.25 91.8228 69.25 88.3071V38.3071H47.375C42.1016 38.3071 38 34.2056 38 28.9321V7.05713H13C9.48438 7.05713 6.75 9.98682 6.75 13.3071V88.3071C6.75 91.8228 9.48438 94.5571 13 94.5571H63ZM47.375 32.0571H69.0547C68.8594 31.6665 68.6641 31.0806 68.2734 30.6899L45.6172 8.03369C45.2266 7.64307 44.6406 7.44775 44.25 7.25244V28.9321C44.25 30.6899 45.6172 32.0571 47.375 32.0571ZM13 0.807129H43.4688C45.8125 0.807129 48.3516 1.979 50.1094 3.73682L72.5703 26.1978C74.3281 27.9556 75.5 30.4946 75.5 32.8384V88.3071C75.5 95.3384 69.8359 100.807 63 100.807H13C5.96875 100.807 0.5 95.3384 0.5 88.3071V13.3071C0.5 6.47119 5.96875 0.807129 13 0.807129Z"
        fill="#6754E2"
      />
      <path
        d="M16.125 13.3071C14.3672 13.3071 13 14.8696 13 16.4321C13 18.1899 14.3672 19.5571 16.125 19.5571H28.625C30.1875 19.5571 31.75 18.1899 31.75 16.4321C31.75 14.8696 30.1875 13.3071 28.625 13.3071H16.125Z"
        fill="#C9C2F5"
      />
      <path
        d="M16.125 25.8071C14.3672 25.8071 13 27.3696 13 28.9321C13 30.6899 14.3672 32.0571 16.125 32.0571H28.625C30.1875 32.0571 31.75 30.6899 31.75 28.9321C31.75 27.3696 30.1875 25.8071 28.625 25.8071H16.125Z"
        fill="#C9C2F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.6667 56.0154H21.3333V64.3488H54.6667V56.0154ZM19.25 47.6821H56.75C60.0703 47.6821 63 50.6118 63 53.9321V66.4321C63 69.9477 60.0703 72.6821 56.75 72.6821H19.25C15.7344 72.6821 13 69.9477 13 66.4321V53.9321C13 50.6118 15.7344 47.6821 19.25 47.6821ZM44.25 85.1821C44.25 83.6196 45.6172 82.0571 47.375 82.0571H59.875C61.4375 82.0571 63 83.6196 63 85.1821C63 86.9399 61.4375 88.3071 59.875 88.3071H47.375C45.6172 88.3071 44.25 86.9399 44.25 85.1821Z"
        fill="#C9C2F5"
      />
    </svg>
  );
}
export default WordDocIcon;
